import moment from "moment";
class details {
  constructor(
    Liquidacion,
    Empleado,
    Legajo,
    Fecha,
    Concepto,
    Centro_de_Costo,
    Cantidad_Liquidada,
    Cantidad_Autorizada,
    Cantidad_No_Autorizada,
    Cantidad_CC
  ) {
    this.Liquidacion = Liquidacion;
    this.Empleado = Empleado;
    this.Legajo = Legajo;
    this.Fecha = moment(Fecha).utc().format("DD-MM-YYYY");
    this.Concepto = Concepto;
    this.Centro_de_Costo = Centro_de_Costo;
    this.Cantidad_Liquidada = this.formatMinutesToHHMM(Cantidad_Liquidada);
    this.Cantidad_Autorizada = this.formatMinutesToHHMM(Cantidad_Autorizada);
    this.Cantidad_No_Autorizada = this.formatMinutesToHHMM(
      Cantidad_No_Autorizada
    );
    this.Cantidad_CC = this.formatMinutesToHHMM(Cantidad_CC);
  }
  formatMinutesToHHMM(totalMinutes) {
    return moment.utc(totalMinutes * 60 * 1000).format("HH:mm");
  }
  static fromJson({
    Liquidacion,
    Empleado,
    Legajo,
    Fecha,
    Concepto,
    Centro_de_Costo,
    Cantidad_Liquidada,
    Cantidad_Autorizada,
    Cantidad_No_Autorizada,
    Cantidad_CC,
  }) {
    return new details(
      Liquidacion,
      Empleado,
      Legajo,
      Fecha,
      Concepto,
      Centro_de_Costo,
      Cantidad_Liquidada,
      Cantidad_Autorizada,
      Cantidad_No_Autorizada,
      Cantidad_CC
    );
  }
}
export default details;
